import React from 'react';
import { CTAButton } from './CTAButton';
type CtaBlockProps = {
  kicker: string;
  label: string;
  subtext?: string;
  tone?: 'light' | 'dark';
  id?: string;
};
export function CtaBlock({
  kicker,
  label,
  subtext = 'One-time payment of $27 USD • 7-day guarantee',
  tone = 'light',
  id
}: CtaBlockProps) {
  const isDark = tone === 'dark';
  return <div id={id} className="mx-auto mt-10 max-w-xl" data-id="element-26" data-mp="1byf63p7833af">
      <p className={`text-balance text-center text-lg font-extrabold leading-snug tracking-tight sm:text-xl ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-27" data-mp="1zpstrhufiap2">
        {kicker}
      </p>
      <div className="mt-4" data-id="element-28" data-mp="1qome1azlt3wv">
        <CTAButton data-id="element-29" data-mp="1qrgxaz6vsiop">{label}</CTAButton>
      </div>
      <p className={`mt-3 text-center text-[11px] font-semibold uppercase tracking-wide sm:text-xs ${isDark ? 'text-navy-200' : 'text-navy-500'}`} data-id="element-30" data-mp="1uq7xjf6n8gg1">
        {subtext}
      </p>
    </div>;
}